import React from 'react';
import { BadgeDollarSign, Clock, Leaf, ShieldCheck, Star, ThumbsUp } from 'lucide-react';
const FEATURES = [{
  icon: BadgeDollarSign,
  title: 'Transparent flat pricing',
  body: 'One all-in price per size. Delivery, pickup, and disposal are included — no surprise fees.'
}, {
  icon: Clock,
  title: 'Fast, reliable delivery',
  body: 'Next-day delivery in most areas, with on-time drop-off and pickup you can count on.'
}, {
  icon: ShieldCheck,
  title: 'Licensed & insured',
  body: 'Fully licensed and insured local haulers who treat your property with care.'
}, {
  icon: Leaf,
  title: 'Responsible disposal',
  body: 'We recycle and divert waste from landfills wherever possible.'
}];
const STATS = [{
  value: '4.9/5',
  label: 'Average rating',
  icon: Star
}, {
  value: '5,000+',
  label: 'Loads hauled',
  icon: ThumbsUp
}, {
  value: 'Same/next-day',
  label: 'Delivery available',
  icon: Clock
}];
export function WhyUs() {
  return <section id="why-us" className="w-full border-t border-border bg-secondary/40 py-16 md:py-24" data-id="element-279">
      <div className="container" data-id="element-280">
        <div className="mx-auto max-w-2xl text-center" data-id="element-281">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-282">
            Why choose Greeneway
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-283">
            A local team built on fair prices, dependable service, and doing
            right by our neighbors.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-284">
          {FEATURES.map(f => <div key={f.title} className="rounded-xl border border-border bg-card p-6" data-id="element-285">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-286">
                <f.icon className="h-5 w-5" data-id="element-287" />
              </span>
              <h3 className="mt-4 text-base font-semibold text-card-foreground" data-id="element-288">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground" data-id="element-289">{f.body}</p>
            </div>)}
        </div>

        <div className="mt-10 grid gap-6 rounded-xl border border-border bg-card p-8 sm:grid-cols-3" data-id="element-290">
          {STATS.map(s => <div key={s.label} className="flex items-center gap-4" data-id="element-291">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-292">
                <s.icon className="h-6 w-6" data-id="element-293" />
              </span>
              <div data-id="element-294">
                <p className="text-2xl font-semibold text-card-foreground" data-id="element-295">
                  {s.value}
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-296">{s.label}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}